import gql from 'graphql-tag';

/**
 * @param {String} field
 * @param {Array} seasons
 * @returns {Object} FRR
 */
export function getHarvestYieldsWitSilageQuery(field: string, seasons: string[] = []) {
  return {
    query: gql`
      fragment Measure on FloatMeasurement {
        unit
        value
      }

      query harvestYields($field: ID!) {
        field(id: $field) {
          id
          seasons {
            seasonTag
            harvest {
              yield(useDryMatterYield: true) {
                wetMass {
                  ...Measure
                }
                dryMass {
                  ...Measure
                }
                moisture {
                  ...Measure
                }
                totalYield {
                  ...Measure
                }
                averageYield {
                  ...Measure
                }
                area {
                  ...Measure
                }
                averageDryYield {
                  ...Measure
                }
                standardisedAverageYield {
                  ...Measure
                }
              }
            }
            crop {
              nominalWeight {
                ...Measure
              }
            }
          }
        }
      }
    `,
    variables: { field, seasons },
  };
}
